exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HgbwD{width:1180px;margin:24px auto}.FlLDo{display:block;margin:0 auto}._3HOd8,._3pN9R,.zP-vG{margin-top:34px;text-align:center;font-size:26px;color:#36404a;font-weight:600}._3pN9R{margin:34px 0 24px;text-align:left}._20szm{color:#ff773a;max-width:750px;overflow:hidden;white-space:nowrap;-o-text-overflow:ellipsis;text-overflow:ellipsis;display:inline-block;vertical-align:bottom}", ""]);

// exports
exports.locals = {
	"courseResult": "HgbwD",
	"noresultImg": "FlLDo",
	"noresult": "_3HOd8",
	"result": "_3pN9R",
	"searching": "zP-vG",
	"item": "_20szm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/search/Search.css
// module id = 1253
// module chunks = 8